module.exports = __webpack_public_path__ + "media/home/three-bags-5ce8d21e.png";